import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import lodash from 'lodash';
import './plugins/leaflet';

Vue.config.productionTip = false;
Vue.prototype.$instanceList = null;
Vue.prototype.$clone = lodash.cloneDeep;

new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
}).$mount('#app');
